import * as React from 'react';
import { H2 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useContactLensProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@swc/helpers';
import 'classnames';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '../../../../../types/product.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/frk-routing';
import '../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '../../../../../hooks/use-product-view-history.js';
import '../../../../../slots/context.js';
import '@grandvisionhq/content';
import '../../types/quantity-discounts.js';
import { isNoRxEntry, isRxEntryOptional } from '../../types/typeguards.js';
import { useCLEcommContext } from '../../context/CLEcommContext.js';
import { ContactLensesRxInfoModal } from '../ContactLensesRxInfoModal/ContactLensesRxInfoModal.js';
import { CLOneColPrescriptionSelector } from './components/CLOneColPrescriptionSelector/CLOneColPrescriptionSelector.js';
import { CLRxableSelectContainer } from './components/CLRxableSelect/CLRxableSelectContainer.js';
import { CLTwoColPrescriptionSelector } from './components/CLTwoColPrescriptionSelector/CLTwoColPrescriptionSelector.js';
import { NoRangesConfigured } from './components/NoRangesConfigured.js';

const CLPrescriptionSelector = ()=>{
    const { getLabel  } = useIntl();
    const { activeVariant: { prescriptionRanges  } ,  } = useContactLensProductData();
    const { selectors , state , triggerToastMessage  } = useCLEcommContext();
    const { // Get the UI validation state for the prescription columns and checkboxes
    columns: { showError: showColumnsError  } , columnCheckboxes: { showError: showCheckboxesError  } , invalidSubmissionsCount , rxEntryType ,  } = state.configurator;
    const isOneColConfigurator = selectors.isOneColConfigurator(state);
    React.useEffect(()=>{
        if (showColumnsError || showCheckboxesError) {
            triggerToastMessage('prescription-form-error');
        }
    }, [
        showColumnsError,
        showCheckboxesError,
        invalidSubmissionsCount
    ]);
    if (!prescriptionRanges || prescriptionRanges.length === 0) {
        return /*#__PURE__*/ React.createElement(NoRangesConfigured, null);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "cl-prescription-selector"
    }, !isNoRxEntry(rxEntryType) && /*#__PURE__*/ React.createElement(H2, {
        className: "cl-prescription-selector__title",
        variant: "heading-smallest"
    }, getLabel('products.contactLenses.prescription.title')), isRxEntryOptional(rxEntryType) && /*#__PURE__*/ React.createElement(CLRxableSelectContainer, null), isOneColConfigurator && /*#__PURE__*/ React.createElement(CLOneColPrescriptionSelector, null), !isOneColConfigurator && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CLTwoColPrescriptionSelector, {
        prescriptionAttributesSet: prescriptionRanges
    }), /*#__PURE__*/ React.createElement(ContactLensesRxInfoModal, {
        className: "cl-prescription-selector__info-modal"
    })));
};

export { CLPrescriptionSelector };
//# sourceMappingURL=CLPrescriptionSelector.js.map
